export enum CollapseState {
  COLLAPSED = 1,
  COLLAPSING,
  EXPANDING,
  EXPANDED,
}
